(function() {
	'use strict';

	angular.module('onboarding.common').controller('usurpCtrl', [
		'$scope', 'usurpService', 'authenticationService', 'USURP_LS',
		function($scope, usurpService, authenticationService, USURP_LS) {
			'use strict';

			this.initialize = function() {
				usurpService.checkUsurpRegular();
			};

			this.loginAnyway = function() {
				usurpService.usurpSession()
					.then(usurpService.checkUsurpRegular);

				localStorage.setItem(USURP_LS.TIMESTAMP, Number(Date.now()));
				localStorage.setItem(USURP_LS.IS_FROM_LOGIN, false);
				usurpService.closeModal();
			};

			this.logout = function() {
				$scope.showSpinner = true;
				authenticationService.logout();
				usurpService.closeModal();
			};
		}
	]);
})();
